import { createI18n } from 'vue-i18n'
import { store } from '../store'
import en from "../../public/json/labels_en.json"
import it from "../../public/json/labels_it.json"
import ru from "../../public/json/labels_ru.json"
import es from "../../public/json/labels_es.json"
import du from "../../public/json/labels_du.json"
import fr from "../../public/json/labels_fr.json"
import de from "../../public/json/labels_de.json"
import us from "../../public/json/labels_us.json"
import ja from "../../public/json/labels_ja.json"
import pt from "../../public/json/labels_pt.json"
import ko from "../../public/json/labels_ko.json"
import hi from "../../public/json/labels_hi.json"
import id from "../../public/json/labels_id.json"
import zh from "../../public/json/labels_zh.json"

let locale = store.getters["preferences/locale"];

const messages = {
  en,
  it,
  ru,
  es,
  du,
  fr,
  de,
  'en-US': us,
  ja,
  pt,
  ko,
  hi,
  id,
  zh
}

const genericDateTimeFormats = {
  time: {
    hour: '2-digit', minute: '2-digit', hour12: false
  },
  time12: {
    hour: '2-digit', minute: '2-digit', hour12: true
  },
  shortNumeric: {
    year: 'numeric', month: '2-digit', day: '2-digit'
  },
  veryShortNumeric: {
    month: '2-digit', day: '2-digit'
  },
  short: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'long', day: 'numeric', weekday: 'long'
  },
  notification: {
    month: 'long', day: 'numeric', weekday: 'long'
  },
  // long: {
  //   year: 'numeric', month: 'short', day: 'numeric',
  //   weekday: 'short', hour: 'numeric', minute: 'numeric'
  // },
  long: {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
  },
  long12: {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
  },
  full: {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  },
  full12: {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
  },
  cycle: {
    month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false
  },
  cycle12: {
    month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true
  }
};

const datetimeFormats = {
  'en': genericDateTimeFormats,
  'it': genericDateTimeFormats,
  'ru': genericDateTimeFormats,
  'es': genericDateTimeFormats,
  'du': genericDateTimeFormats,
  'fr': genericDateTimeFormats,
  'de': genericDateTimeFormats,
  'en-US': genericDateTimeFormats,
  'ja': genericDateTimeFormats,
  'pt': genericDateTimeFormats,
  'ko': genericDateTimeFormats,
  'hi': genericDateTimeFormats,
  'id': genericDateTimeFormats,
  'zh': genericDateTimeFormats,
}

const currencies = {
  USD: { style: 'currency', currency: 'USD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  EUR: { style: 'currency', currency: 'EUR', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  JPY: { style: 'currency', currency: 'JPY', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  GBP: { style: 'currency', currency: 'GBP', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  BRL: { style: 'currency', currency: 'BRL', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  COP: { style: 'currency', currency: 'COP', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  CLP: { style: 'currency', currency: 'CLP', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  MXN: { style: 'currency', currency: 'MXN', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  ARS: { style: 'currency', currency: 'ARS', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  CHF: { style: 'currency', currency: 'CHF', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  DKK: { style: 'currency', currency: 'DKK', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  SAR: { style: 'currency', currency: 'SAR', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  TWD: { style: 'currency', currency: 'TWD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  SGD: { style: 'currency', currency: 'SGD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  AED: { style: 'currency', currency: 'AED', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  THB: { style: 'currency', currency: 'THB', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  CRC: { style: 'currency', currency: 'CRC', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  PEN: { style: 'currency', currency: 'PEN', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  KRW: { style: 'currency', currency: 'KRW', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  PHP: { style: 'currency', currency: 'PHP', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  VES: { style: 'currency', currency: 'VES', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  GTQ: { style: 'currency', currency: 'GTQ', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  AUD: { style: 'currency', currency: 'AUD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  CAD: { style: 'currency', currency: 'CAD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  PLN: { style: 'currency', currency: 'PLN', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  NZD: { style: 'currency', currency: 'NZD', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  CZK: { style: 'currency', currency: 'CZK', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  SEK: { style: 'currency', currency: 'SEK', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  NOK: { style: 'currency', currency: 'NOK', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  INR: { style: 'currency', currency: 'INR', useGrouping: true, currencyDisplay: 'narrowSymbol' },
  IDR: { style: 'currency', currency: 'IDR', useGrouping: true, currencyDisplay: 'narrowSymbol' },
};

const numberFormats = {
  'en': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'it': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'ru': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'es': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'du': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'fr': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'de': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'en-US': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'ja': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'pt': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'BRL'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    },
  },
  'ko': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'KRW'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    },
  },
  'hi': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'id': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
  'zh': {
    ...currencies,
    ...{
      currency: {
        style: 'currency', currency: 'EUR'
      },
      temperature: {
        style: 'decimal', minimumFractionDigits: 1, maximumFractionDigits: 1
      },
      power: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      money: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      co2: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      integer: {
        style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 0
      }
    }
  },
}

export const i18n = createI18n({
  locale: locale ? locale : 'en',
  fallbackLocale: 'en',
  messages,
  datetimeFormats,
  numberFormats,
})
